import axios from "../api";
/**
 * Swap options for the ratings a streamlined solution asks for: club cards
 * (signed in) and market cards a slot of each rating can take instead, kept
 * to the challenge's league / club / country requirements when `sbcId` is given.
 */
export const getStreamlinedOptions = async (ratings, sbcId) => {
    const res = await axios.get(`/streamlined-sbcs/options?ratings=${ratings.join(",")}` +
        (sbcId ? `&sbcId=${sbcId}` : ""));
    return res.data;
};
//# sourceMappingURL=getStreamlinedOptions.js.map